/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import { Component, createRef } from 'react';

import { connect } from 'react-redux';


import './AboutUs.scss';


/**


@Author Karthik

@param

@return html code for Help Page

**/

class AboutUs extends Component {
    constructor(props) {
        super(props);
        this.scrollRef = createRef();
        this.state = {
            pageLoading: false,
            scrollHeight: 158,
            section: null,
            innerWidth: window.innerWidth,
            isVisible: false,
            pageClientWidth: 16
        };
    }

    componentDidMount() {
        window.addEventListener('resize', this.headerStickyHandle);
        this.headerStickyHandle();
        this.initialMethod();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.match.params.section !== this.props.match.params.section) {
            this.initialMethod();
        }
        window.addEventListener('resize', this.headerStickyHandle);
    }

    initialMethod = () => {
        this.setState({
            section: this.props.match.params.section
        });
    }

    navigateToAbout = (flag) => {
        this.props.history.push(`/help/${flag}`);
    }

    scrollToTop = () => {
        this.scrollRef.current.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }

    headerStickyHandle = () => {
        const header = document.getElementsByClassName('breadcrumb-section')[0].getBoundingClientRect();
        this.setState({
            scrollHeight: header.bottom,
            innerWidth: window.innerWidth,
            pageClientWidth: this.scrollRef?.current?.clientWidth
        })
    }

    /* Called when scroll content */
    handleScroll = (event) => {
        try {
            this.setState({
                isVisible: (event.target.scrollHeight / 4) < event.target.scrollTop,
                pageClientWidth: this.scrollRef?.current?.clientWidth
            });
        } catch (e) {
            this.setState({
                isVisible: false
            });
        }
    };

    componentWillUnmount() {
        window.removeEventListener('resize', this.headerStickyHandle);
    }

    render() {
        return (
            <div className="about-us-main">
                {
                    this.state.pageLoading ?
                        <div className="loader d-flex align-items-center justify-content-center">
                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/loader.gif`} className="loader-icon" alt="loader-icon"></img>
                        </div> : <div className="about-us">
                            <div className="breadcrumb-section">
                                <div className="h4 remove-bottom text-center custom-bold-text colored-text">
                                    About Us
                                </div>
                            </div>
                            <div className="scroll-content" style={{ height: `calc(100% - ${this.state.scrollHeight}px)` }} ref={this.scrollRef} onScroll={this.handleScroll}>
                                {
                                    this.state.isVisible ?
                                        <div className="scroll-top d-flex align-items-center justify-content-center clickable" style={{ right: `${window.innerWidth - this.state.pageClientWidth}px` }} onClick={this.scrollToTop}>
                                            <i className="fas fa-arrow-up"></i>
                                        </div> : null
                                }

                                <div className={`d-flex align-items-center justify-content-center ${this.state.noData ? 'h-75' : ''}`}>
                                    <div className="large-screen-width">
                                        <div className="d-flex align-items-center justify-content-center">
                                            <div className="about-us-content">
                                                <div className="content-box">
                                                    <div className="custom-bold-text colored-text pt-5">About Caring Transitions</div>
                                                    <div className="content-conatiner">
                                                        As a result of life events such as downsizing, disability, divorce and the death of a loved one,
                                                        individuals and families often find it necessary to part with personal belongings. Caring Transitions
                                                        can handle all your needs. From emptying the kitchen cabinets to managing entire estates, we can
                                                        provide you the services you need.
                                                    </div>
                                                    <div className="content-conatiner">
                                                        At Caring Transitions, we help people needing to get rid of personal belongs due to the lack of need, space,
                                                        time or value. To maximize our clients' returns and minimize their stress and involvement, we seek the best
                                                        solutions to their personal situations. They may involve a combination of approaches from selling items locally
                                                        through an estate sale, over the internet through online auctions services or through specialized brokers.
                                                        We also handle charitable donations and/or the disposal of items that have little value or may require a disposal
                                                        specialist when the condition is not appropriate for sale.
                                                    </div>
                                                    <div className="custom-bold-text colored-text pt-5">Our Locations</div>
                                                    <div className="content-conatiner">
                                                        Caring Transitions' North American offices are locally owned and operated and are backed by a national
                                                        network of dedicated, caring experts and resources. We offer affordable, professional services while keeping your best interests at heart.
                                                    </div>
                                                    <div className="content-conatiner pt-3">
                                                        <div className="text-bold">
                                                            Call us for a Consultation - (844) 220-5427
                                                        </div>
                                                        <div className="text-bold">
                                                            Find a location on our website - www.CaringTransitions.com
                                                        </div>
                                                        <div className="text-bold">
                                                            Caring Transitions. The Leader in Senior Relocation, Downsizing and Estate Sales. Your Total Solution for Peace of Mind and Minimizing Stress.
                                                        </div>
                                                        <div>
                                                            Each office is independently owned and operated.
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                }
            </div>
        );
    }
}

export default connect(state => state)(AboutUs);